<template>
  <v-card
    outlined
    class="h-100 d-flex w-100 pa-4 rounded-lg"
    :class="isActive ? 'card-active' : 'routine-extent-card'"
    :ripple="false"
    @click="$emit('click')"
  >
    <div
      class="icon-container d-flex justify-center align-center rounded"
      :class="isActive ? 'blue' : 'blue-grey lighten-1'"
    >
      <v-icon class="font-size-24" color="white">{{ icon }}</v-icon>
    </div>
    <div class="d-flex flex-column ml-4">
      <span
        class="ma-0 pa-0 subtitle2 font-weight-600 mb-1"
        :class="isActive ? 'blue--text' : 'blue-grey--text text--darken-3'"
      >
        {{ title }}
      </span>

      <span
        class="ma-0 pa-0 caption"
        :class="isActive ? 'blue--text' : 'blue-grey--text text--darken-1'"
        v-snip="3"
      >
        {{ description }}
      </span>
    </div>
  </v-card>
</template>

<script>
export default {
  name: 'RoutineExtentCard',

  props: {
    title: { required: true, type: String },
    icon: { required: true, type: String },
    description: { required: true, type: String },
    isActive: { required: true, type: Boolean, default: false },
  },
}
</script>
<style lang="scss" scoped>
.routine-extent-card {
  &:hover {
    background-color: $color-blue-grey-lighten3 !important;
  }
}

.card-active {
  background-color: $color-blue-lighten2 !important;
  border-color: $color-blue !important;
  border-color: $color-blue !important;
  &::before {
    border-color: $color-blue !important;
    background-color: $color-blue-lighten2 !important;
  }
}

.icon-container {
  min-width: 40px !important;
  height: 40px !important;
}
</style>
